import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import icon from 'flarum/common/helpers/icon';
import { truncate } from 'flarum/common/utils/string';

/**
 * The club's pinned message, shown above the posts of the club discussion.
 *
 * The forum payload only carries the post id; the post is loaded through the
 * normal API, so only people who can read the club ever get its content.
 *
 * Attrs: postId, stream (the page's PostStreamState)
 */
export default class ClubPinnedPost extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.requested = null;
  }

  view() {
    const post = this.post();

    if (!post || post.isHidden() || !post.user || post.contentType() !== 'comment') return null;

    return (
      <div className="ClubPinnedPost">
        <div className="ClubPinnedPost-label">
          {icon('fas fa-thumbtack')} {app.translator.trans('happydigital-clubs.forum.pin.box_label')}
        </div>
        <div className="ClubPinnedPost-body">
          {post.user() ? avatar(post.user()) : null}
          <div className="ClubPinnedPost-text">
            <strong>{post.user() ? username(post.user()) : null}</strong>
            <p>{truncate(post.contentPlain() || '', 200)}</p>
          </div>
        </div>
        {Button.component(
          {
            className: 'Button Button--link ClubPinnedPost-go',
            icon: 'fas fa-arrow-down',
            onclick: (e) => {
              // Mithril redraws right after a click handler. If the pinned
              // post is not loaded yet (any long discussion), that redraw
              // reaches the post stream before the posts arrive and uses up
              // its pending scroll, so the page stops somewhere else.
              // goToNumber() redraws by itself once the posts are in.
              e.redraw = false;
              this.goTo(post);
            },
          },
          app.translator.trans('happydigital-clubs.forum.pin.go_to')
        )}
      </div>
    );
  }

  /**
   * The pinned post from the store, fetching it once if it is not there yet
   * (it may be far from the posts loaded on the first page).
   */
  post() {
    const id = String(this.attrs.postId);
    const post = app.store.getById('posts', id);

    if (!post && this.requested !== id) {
      this.requested = id;
      app.store
        .find('posts', id)
        .catch(() => {})
        .then(() => m.redraw());
    }

    return post;
  }

  goTo(post) {
    if (this.attrs.stream) {
      this.attrs.stream.goToNumber(post.number());
    } else {
      m.route.set(app.route.discussion(post.discussion(), post.number()));
    }
  }
}
